export async function getRoles() {
  const token = localStorage.getItem('token');
  const res = await fetch('/api/rbac/roles', { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Failed to fetch roles');
  return res.json();
}

